"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingLabelClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const errors_1 = require("@deliverr/errors");
const ShippingLabelExceptions_1 = require("./ShippingLabelExceptions");
const DEFAULT_LABEL_PURCHASE_FORMAT = "ZPL203";
const FULFILLMENT_LABEL_BASE_URL = (_a = process.env.FULFILLMENT_LABEL_BASE_URL) !== null && _a !== void 0 ? _a : process.env.FULFILLMENT_SERVICE_URL;
const FULFILLMENT_LABEL_BASIC_AUTH_USER = (_b = process.env.FULFILLMENT_LABEL_BASIC_AUTH_USER) !== null && _b !== void 0 ? _b : process.env.FULFILLMENT_BASIC_AUTH_USER;
const FULFILLMENT_LABEL_BASIC_AUTH_PASSWORD = (_c = process.env.FULFILLMENT_LABEL_BASIC_AUTH_PASSWORD) !== null && _c !== void 0 ? _c : process.env.FULFILLMENT_BASIC_AUTH_PASSWORD;
class ShippingLabelClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = {}) {
        var _a, _b;
        super(Object.assign(Object.assign({}, config), { baseURL: config.baseURL || `${FULFILLMENT_LABEL_BASE_URL}`, basicAuthUser: ((_a = config.auth) === null || _a === void 0 ? void 0 : _a.username) || `${FULFILLMENT_LABEL_BASIC_AUTH_USER}`, basicAuthPassword: ((_b = config.auth) === null || _b === void 0 ? void 0 : _b.password) || `${FULFILLMENT_LABEL_BASIC_AUTH_PASSWORD}` }));
        if (!FULFILLMENT_LABEL_BASIC_AUTH_USER || !FULFILLMENT_LABEL_BASIC_AUTH_PASSWORD) {
            commons_logs_1.log.warn("FULFILLMENT_LABEL_BASIC_AUTH_USER and FULFILLMENT_LABEL_BASIC_AUTH_PASSWORD environment variable is not set");
        }
    }
    async getLabelsSummaryByTrackingCode(trackingCode) {
        const url = `/v1/labels/trackingCode/${trackingCode}/summary`;
        try {
            return await this.get(url);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getShippingLabelByTrackingCode(trackingCode) {
        try {
            return await this.get(`/v1/labels/trackingCode/${trackingCode}`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async generateDhlManifest(dhlPickupAccount) {
        commons_logs_1.log.info({ fn: "generateDhlManifest", dhlPickupAccount });
        try {
            return await this.post(`/v1/closeout/${dhlPickupAccount}`, {}).then((response) => response.contents);
        }
        catch (error) {
            throw (0, base_client_1.mapError)(error);
        }
    }
    async getLabelDataByShipmentId(shipmentId) {
        try {
            return await this.get(`/v1/labels/shipmentId/${shipmentId}`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async cancelShippingLabel(id, labelId) {
        const ctx = { fn: "cancelShippingLabel", shipmentId: id, labelId };
        commons_logs_1.log.info(ctx, "start");
        try {
            await this.delete(`/v1/shipment/${id}/label/${labelId}`);
        }
        catch (err) {
            commons_logs_1.log.error(Object.assign(Object.assign({}, ctx), { err }), "ShippingLabelClient error");
            throw (0, base_client_1.mapError)(err);
        }
    }
    async prepurchaseLabels(shippingLabelPrepurchaseRequest) {
        commons_logs_1.log.info({
            fn: "prepurchaseLabels",
            marketplaceOrderId: shippingLabelPrepurchaseRequest.marketplaceOrderId,
            shipmentIds: shippingLabelPrepurchaseRequest.shipments.map(({ id }) => id),
        });
        try {
            return await this.post(`/v1/labels/prepurchase`, shippingLabelPrepurchaseRequest);
        }
        catch (error) {
            throw (0, base_client_1.mapError)(error);
        }
    }
    async getShippingLabel(shipmentId, labelId, unzip = false, labelFormat = DEFAULT_LABEL_PURCHASE_FORMAT) {
        const ctx = {
            fn: "getShippingLabel",
            shipmentId,
            labelId,
            unzip,
            labelFormat,
        };
        commons_logs_1.log.info(ctx, "start");
        try {
            return await this.get(`/v1/shipment/${shipmentId}/label/${labelId}`, {
                unzip,
                labelFormat,
            });
        }
        catch (err) {
            commons_logs_1.log.error(Object.assign(Object.assign({}, ctx), { err }), "ShippingLabelClient error");
            throw (0, base_client_1.mapError)(err);
        }
    }
    async purchaseShippingLabel(shipmentId, length, width, height, weight, items, labelFormat = DEFAULT_LABEL_PURCHASE_FORMAT, unzip = false, marketplaceOrderId) {
        const query = { labelFormat, unzip };
        const body = { length, width, height, weight, items, marketplaceOrderId };
        const ctx = {
            fn: "purchaseShippingLabel",
            shipmentId,
            items,
            unzip,
            labelFormat,
            marketplaceOrderId,
        };
        commons_logs_1.log.info(ctx, "start");
        try {
            return await this.post(`/v2/shipment/${shipmentId}/label`, body, query);
        }
        catch (err) {
            commons_logs_1.log.error(Object.assign(Object.assign({}, ctx), { err }), "ShippingLabelClient error");
            throw (0, base_client_1.mapError)(err);
        }
    }
    async purchaseShippingLabelTextErrors(shipmentId, length, width, height, weight, items, labelFormat = DEFAULT_LABEL_PURCHASE_FORMAT, unzip = false, marketplaceOrderId) {
        const query = { labelFormat, unzip };
        const body = { length, width, height, weight, items, marketplaceOrderId };
        const ctx = {
            fn: "purchaseShippingLabelTextErrors",
            shipmentId,
            items,
            unzip,
            labelFormat,
            marketplaceOrderId,
        };
        commons_logs_1.log.info(ctx, "start");
        try {
            return await this.post(`/v1/shipment/${shipmentId}/label`, body, query);
        }
        catch (err) {
            commons_logs_1.log.error(Object.assign(Object.assign({}, ctx), { err }), "ShippingLabelClient error");
            throw (0, base_client_1.mapError)(err);
        }
    }
    async requestLabelsAsync(labelRequest) {
        const { shipmentId, printRequestId, length, width, height, weight, items, data } = labelRequest;
        const body = { printRequestId, length, width, height, weight, items, data };
        const ctx = {
            fn: "requestLabelsAsync",
            shipmentId,
            printRequestId,
            length,
            width,
            height,
            weight,
            items,
            data,
        };
        commons_logs_1.log.info(ctx, "start");
        try {
            return await this.post(`/v3/shipment/${shipmentId}/labels`, body);
        }
        catch (err) {
            commons_logs_1.log.error(Object.assign(Object.assign({}, ctx), { err }), "ShippingLabelClient error");
            switch (err.response && err.response.data && err.response.data.error) {
                case ShippingLabelExceptions_1.ShippingLabelExceptions.INVALID_SHIPMENT_STATUS:
                case ShippingLabelExceptions_1.ShippingLabelExceptions.SHIPMENT_NOT_FOUND:
                case ShippingLabelExceptions_1.ShippingLabelExceptions.SHIPMENT_CANCELLED:
                    throw new errors_1.DeliverrError({
                        code: err.response.data.error,
                        payload: err,
                    });
                case ShippingLabelExceptions_1.ShippingLabelExceptions.NOT_FOUND:
                    throw new errors_1.DeliverrError({
                        code: ShippingLabelExceptions_1.ShippingLabelExceptions.SHIPMENT_NOT_FOUND,
                        payload: err,
                    });
                default:
                    throw new errors_1.DeliverrError({
                        code: errors_1.ApiError.UNKNOWN_ERROR,
                        payload: err,
                    });
            }
        }
    }
}
exports.ShippingLabelClient = ShippingLabelClient;
//# sourceMappingURL=ShippingLabelClient.js.map